/*
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2022-05-16 11:29:13
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-09 16:23:42
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import router from './router/index'
// import VueAxios from 'vue-axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 各API接口
import api from './api/api' // 导入api接口
// 首页模板
import App from './components/page/App.vue'
// 状态管理
import store from './vuex/store'
// vconsole
// import VConsole from 'vconsole'
// new VConsole();

// 全局参数
const publicData = {
}

Vue.prototype.publicData = publicData

Vue.config.productionTip = false
Vue.prototype.$api = api // 将api挂载到vue的原型上

// Vue.prototype.$url = 'https://gxqgwh.oss-cn-zhangjiakou.aliyuncs.com/' //图片地址拼接用测式服
Vue.prototype.$url = 'http://www.hskfq.gov.cn' //图片地址拼接用正式服


// if (location.origin.indexOf('gwh_h5') != -1 || location.origin.indexOf('localhost') != -1) {
// Vue.prototype.$url = 'http://gwh.shanmuzhi.com' // 域名，后边图片地址拼接用测式服
// } else {
//   Vue.prototype.$url = 'http://www.hskfq.gov.cn' // 域名，后边图片地址拼接用正式服
// }
router.afterEach((to, from, next) => {
    console.log("to, from, next",to, from, next);
    setTimeout(() => {
        console.log("百度统计11");
        let url = localStorage.getItem("tongji_url");
        // 此处粘贴百度统计复制过来的代码-正式
          var _hmt = _hmt || [];
          (function() {
            var hm = document.createElement("script");
            hm.src = url+"?6da8dc2ae26f25400340315dc39d65bc";
            var s = document.getElementsByTagName("script")[0]; 
            s.parentNode.insertBefore(hm, s);
        })();
        // 测试
        // var _hmt = _hmt || [];
        // (function () {
        //     var hm = document.createElement("script");
        //     hm.src = url+"?47e4215162ede34f21135d5650d00670";
        //     var s = document.getElementsByTagName("script")[0];
        //     s.parentNode.insertBefore(hm, s);
        // })();
        console.log("百度统计22",url);
    }, 300);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
